export default __webpack_public_path__ + "static/media/yellow1.b691a54b.png";